import React from "react";
import { Link, useLocation } from "react-router-dom";
import NavBar from "../../components/common/NavBar";
import useTranslation from "../../i18n/useTranslation";

export default function CheckoutSuccess() {
    const { t } = useTranslation();
    const search = new URLSearchParams(useLocation().search);
    const cid = search.get("cid");

    const navBarElem = {
        pageTitle: t('checkout.paymentSuccess'),
        links: [
            { pageTitle: t('campaigns.advertising'), navLink: null, active: false },
            { pageTitle: t('campaigns.campaigns'), navLink: "/advertise/campaign", active: false },
            { pageTitle: t('checkout.paymentSuccess'), navLink: null, active: true },
        ],
    };

    return (
        <div className="content-wrapper">
            <NavBar navBarElem={navBarElem} />

            <section className="content p-3">
                <div className="row">
                    <div className="col-12 col-lg-8 mx-auto">
                        <div className="card card-outline card-success">
                            <div className="card-header">
                                <h3 className="card-title">{t('checkout.paymentReceived')}</h3>
                            </div>

                            <div className="card-body">
                                <div className="alert alert-success mb-3">
                                    {t('checkout.paymentSuccessMessage')}
                                </div>

                                <div className="d-flex flex-wrap" style={{ gap: 10 }}>
                                    {cid ? (
                                        <>
                                            <Link
                                                to={`/advertise/campaign/${encodeURIComponent(cid)}/review`}
                                                className="btn btn-success"
                                            >
                                                {t('checkout.openReview')}
                                            </Link>

                                            <Link
                                                to={`/advertise/campaign/${encodeURIComponent(cid)}/edit`}
                                                className="btn btn-outline-secondary"
                                            >
                                                {t('campaigns.editCampaign')}
                                            </Link>

                                            <Link
                                                to="/advertise/campaign"
                                                className="btn btn-outline-dark"
                                            >
                                                {t('checkout.campaignList')}
                                            </Link>
                                        </>
                                    ) : (
                                        <Link to="/advertise/campaign" className="btn btn-success">
                                            {t('checkout.backToCampaigns')}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}